import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var CodeInfo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CodeInfo, _React$Component);

  function CodeInfo() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CodeInfo.prototype;

  _proto.render = function render() {
    var _this$props$data = this.props.data,
        filename = _this$props$data.filename,
        lineNum = _this$props$data.lineNum,
        linkUrl = _this$props$data.linkUrl;
    return linkUrl && /*#__PURE__*/React.createElement("span", {
      className: "code-info"
    }, /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, /*#__PURE__*/React.createElement("a", {
      href: linkUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, filename)), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, /*#__PURE__*/React.createElement("a", {
      href: linkUrl + "#L" + lineNum,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "line ", lineNum)));
  };

  return CodeInfo;
}(React.Component);

export default CodeInfo;